module.exports = __webpack_public_path__ + "0bfc93bb837d741cabe5a2d15fb20d15.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/full-checkmark.svg
// module id = 1314
// module chunks = 65